import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "space-y-4"
};
const _hoisted_2 = {
  key: 0,
  class: "p-4 bg-yellow-50 border border-yellow-200 rounded text-yellow-800"
};
const _hoisted_3 = {
  key: 1,
  class: "space-y-6"
};
const _hoisted_4 = {
  key: 0,
  class: "text-gray-700"
};
const _hoisted_5 = {
  key: 1,
  class: "text-gray-700"
};
const _hoisted_6 = {
  class: "space-y-4"
};
const _hoisted_7 = {
  key: 0,
  class: "space-y-6 pl-6 border-l-2 border-gray-200"
};
const _hoisted_8 = {
  class: "space-y-2"
};
const _hoisted_9 = {
  class: "block text-sm font-medium text-gray-700"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 0,
  class: "space-y-6"
};
const _hoisted_12 = {
  class: "space-y-2"
};
const _hoisted_13 = {
  class: "block text-sm font-medium text-gray-700"
};
const _hoisted_14 = {
  key: 0
};
import { ref, reactive, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '../../../services/UserService/useMeStore';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import RouteService from '../../../services/RouteService';
import LlCheckbox from '../../../components/LlCheckbox.vue';
import LlSelect from '../../../components/LlSelect.vue';
import LlTooltip from '../../../components/LlTooltip.vue';
import Loader from '../../../components/Loader.vue';
import LlSecondaryButton from '../../../components/LlSecondaryButton.vue';

// Define props for Angular services (maintains compatibility)

export default {
  __name: 'ClassTrackingSetup',
  props: {
    company: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    },
    leanLawApi: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: true
    },
    rootScope: {
      type: Object,
      required: true
    },
    lists: {
      type: Object,
      required: false
    }
  },
  emits: ['close'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;

    // Define emits
    const emit = __emit;

    // Initialize Pinia stores
    const meStore = useMeStore();
    const {
      me
    } = storeToRefs(meStore);

    // Convert data() to reactive state
    const loading = ref(true);
    const saving = ref(false);
    const accounting = reactive({
      classesEnabled: false,
      classesTransactions: false
    });
    const classes = ref([]);
    const tagSettings = reactive({
      enabled: false,
      invoicePrimary: true,
      createAccountTags: true,
      assignAccountToExpenses: true,
      defaultServices: null,
      expenses: null
    });
    const primaryTerm = ref('');
    const routeService = ref(null);

    // Component initialization (replaces mounted())
    onMounted(async () => {
      const {
        handleError
      } = useSnackbarHandler();
      routeService.value = new RouteService(props);
      try {
        const userData = await props.userService.me();
        const accountingSettings = await props.leanLawApi.getAccountingSettings();
        Object.assign(accounting, accountingSettings);
        const classesResponse = await props.leanLawApi.listAccountingClasses();
        classes.value = classesResponse.classes;
        primaryTerm.value = props.lists?.matterRoleFromId?.('primary') || 'Primary Attorney';
        const companyTags = userData.company?.settings?.tags || {};
        Object.assign(tagSettings, companyTags);

        // Set default values if not enabled
        if (!tagSettings.enabled) {
          tagSettings.invoicePrimary = true;
          tagSettings.createAccountTags = true;
          tagSettings.assignAccountToExpenses = true;
        }

        // Helper function to find and link class objects to dropdown selections
        const linkClassToSetting = settingKey => {
          if (tagSettings[settingKey] && classes.value) {
            const matchingClass = classes.value.find(c => c.id === (tagSettings[settingKey].id || tagSettings[settingKey]));
            if (matchingClass) {
              tagSettings[settingKey] = matchingClass;
            }
          }
        };

        // Ensure dropdown objects are properly linked to actual class objects from the response
        linkClassToSetting('defaultServices');
        linkClassToSetting('expenses');
        loading.value = false;
      } catch (err) {
        props.alerts.error(err);
        handleError(err);
        emit('close');
      }
    });

    // Methods
    const save = async () => {
      saving.value = true;
      try {
        const tagsToSave = {
          ...tagSettings
        };
        if (tagsToSave.defaultServices && typeof tagsToSave.defaultServices === 'object') {
          tagsToSave.defaultServices = {
            id: tagsToSave.defaultServices.id,
            name: tagsToSave.defaultServices.name,
            type: "class"
          };
        }
        if (tagsToSave.expenses && typeof tagsToSave.expenses === 'object') {
          tagsToSave.expenses = {
            id: tagsToSave.expenses.id,
            name: tagsToSave.expenses.name,
            type: "class"
          };
        }
        await props.leanLawApi.updateMyCompany({
          body: {
            settings: {
              tags: tagsToSave
            }
          }
        });

        // Refresh user data so the modal shows updated settings on next open
        await props.userService.reload();

        // Show success message
        props.alerts.success('Class tracking settings updated successfully');
        emit('close');
      } catch (err) {
        saving.value = false;
        props.alerts.error(err);
      }
    };
    const cancel = () => {
      emit('close');
    };
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, {
        class: "w-[500px] max-h-[80vh] flex flex-col"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card_title, {
          class: "text-xl font-normal pb-4"
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createElementVNode("div", {
            class: "relative inline-block"
          }, [_createTextVNode(" Class Tracking Setup "), _createElementVNode("div", {
            class: "absolute bottom-0 left-0 w-full h-0.5 bg-primary"
          })], -1)]))]),
          _: 1
        }), _createVNode(_component_v_card_text, {
          class: "flex-1 overflow-y-auto p-6"
        }, {
          default: _withCtx(() => [_cache[15] || (_cache[15] = _createElementVNode("p", {
            class: "mb-4 text-gray-600"
          }, " Class tracking is for setting the \"Class\" field on invoices or invoice line items that are sent to QuickBooks. ", -1)), loading.value ? (_openBlock(), _createBlock(Loader, {
            key: 0,
            class: "text-center py-8"
          })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [!accounting.classesEnabled ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[7] || (_cache[7] = [_createTextVNode(" You don't have \"classes\" enabled in your QuickBooks account. Only some QuickBooks subscription have this option. To enable, go to ", -1), _createElementVNode("strong", null, "Company Settings in QuickBooks", -1), _createTextVNode(". ", -1)]))])) : _createCommentVNode("", true), accounting.classesEnabled ? (_openBlock(), _createElementBlock("div", _hoisted_3, [accounting.classesTransactions ? (_openBlock(), _createElementBlock("p", _hoisted_4, [...(_cache[8] || (_cache[8] = [_createTextVNode(" Your QuickBooks is enabled for class tracking with the option \"One for each transaction\". This means that we assign a class to the ", -1), _createElementVNode("strong", null, "invoice as a whole", -1), _createTextVNode(" as opposed to individual line items. ", -1)]))])) : (_openBlock(), _createElementBlock("p", _hoisted_5, [...(_cache[9] || (_cache[9] = [_createTextVNode(" Your QuickBooks is enabled for class tracking with the option \"Each row in transaction\". This means that we assign classes to ", -1), _createElementVNode("strong", null, "each line item", -1), _createTextVNode(" in an invoice. ", -1)]))])), _createElementVNode("div", _hoisted_6, [_createVNode(LlCheckbox, {
            modelValue: tagSettings.enabled,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => tagSettings.enabled = $event),
            label: "Use Class Tracking for Invoices",
            "label-class": "text-gray-700"
          }, null, 8, ["modelValue"]), tagSettings.enabled ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_cache[14] || (_cache[14] = _createElementVNode("p", {
            class: "text-gray-600"
          }, "Invoices will be tagged with a class mapped to each user in the system.", -1)), _createVNode(LlCheckbox, {
            modelValue: tagSettings.createAccountTags,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => tagSettings.createAccountTags = $event),
            label: "Automatically create classes in QuickBooks for users as needed",
            "label-class": "text-gray-700"
          }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_8, [_createElementVNode("label", _hoisted_9, [_cache[11] || (_cache[11] = _createTextVNode(" Default Class", -1)), !accounting.classesTransactions ? (_openBlock(), _createElementBlock("span", _hoisted_10, " for Services")) : _createCommentVNode("", true), _createVNode(LlTooltip, {
            icon: "help",
            class: "ml-1"
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("Used when it is not possible to map an item to a class another way", -1)]))]),
            _: 1
          })]), _createVNode(LlSelect, {
            modelValue: tagSettings.defaultServices,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => tagSettings.defaultServices = $event),
            items: classes.value,
            placeholder: "Default Service Class",
            clearable: true,
            "item-title": 'name',
            "return-object": true,
            class: "w-72"
          }, null, 8, ["modelValue", "items"])]), !accounting.classesTransactions ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(LlCheckbox, {
            modelValue: tagSettings.invoicePrimary,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => tagSettings.invoicePrimary = $event),
            label: `Track with ${primaryTerm.value || 'Primary Attorney'} for each ${_unref(me)?.terms?.matter || 'Matter'}`,
            "label-class": "text-gray-700",
            info: "For each line item on an invoice, the class will be applied either with the responsible for the matter (if option is checked), or with the person that tracked that time entry (if option is not checked)"
          }, null, 8, ["modelValue", "label"]), _createVNode(LlCheckbox, {
            modelValue: tagSettings.assignAccountToExpenses,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => tagSettings.assignAccountToExpenses = $event),
            label: "Assign Expenses to Users",
            "label-class": "text-gray-700"
          }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_12, [_createElementVNode("label", _hoisted_13, [_cache[12] || (_cache[12] = _createTextVNode(" Class for ", -1)), tagSettings.assignAccountToExpenses ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Unassigned")) : _createCommentVNode("", true), _cache[13] || (_cache[13] = _createTextVNode(" Expenses ", -1))]), _createVNode(LlSelect, {
            modelValue: tagSettings.expenses,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => tagSettings.expenses = $event),
            items: classes.value,
            placeholder: "Expense Class",
            clearable: true,
            "item-title": 'name',
            "return-object": true,
            class: "w-72"
          }, null, 8, ["modelValue", "items"])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]))]),
          _: 1
        }), _createVNode(_component_v_card_actions, {
          class: "border-t border-gray-200 p-6 flex justify-start space-x-3"
        }, {
          default: _withCtx(() => [_createVNode(LlSecondaryButton, {
            id: "save",
            onBtnClick: save,
            color: "primary",
            disabled: loading.value || saving.value || !accounting.classesEnabled
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode(" Save Settings ", -1)]))]),
            _: 1
          }, 8, ["disabled"]), _createVNode(LlSecondaryButton, {
            onBtnClick: cancel
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode(" Cancel ", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};